import { get } from 'http';
import { useState } from 'react';
import TrainerButton from './TrainerButton';

interface SelectableImageGridProps {
  width: number;
  height: number;
  images: string[];
  selectable: boolean;
  selectedImageIndexes?: number[];
  updateSelectedImageIndexes?: (imageIndexes: number[]) => void;
}
const SelectableImageGrid = ({
  width,
  height,
  images,
  selectable,
  selectedImageIndexes,
  updateSelectedImageIndexes,
}: SelectableImageGridProps) => {
  const onImageClick = (index: number) => {
    if (!selectable || !updateSelectedImageIndexes || !selectedImageIndexes)
      return;
    selectedImageIndexes.includes(index)
      ? updateSelectedImageIndexes(
          selectedImageIndexes.filter(
            selectedImageIndexes => selectedImageIndexes !== index,
          ),
        )
      : updateSelectedImageIndexes([...selectedImageIndexes, index]);
  };
  return (
    <div
      className="relative grid size-full"
      style={{
        gridTemplateColumns: getGridTemplateString(width, 4),
        gridTemplateRows: getGridTemplateString(height, 4),
      }}>
      {images.map((image, index) => (
        <div
          className={
            selectable &&
            selectedImageIndexes &&
            selectedImageIndexes.includes(index)
              ? 'border-2 border-electricBlue-600'
              : ''
          }
          key={index}
          onClick={() => {
            onImageClick(index);
          }}>
          <img
            src={image}
            alt={`image-${index}`}
            className="size-full object-contain"
          />
        </div>
      ))}
    </div>
  );
};

function getGridTemplateString(length: number, gap: number) {
  return Array.from({ length: length })
    .map(() => `${100 / length}%`)
    .join(' ');
}
export default SelectableImageGrid;
